import { createPortal } from "react-dom"
import styled from "styled-components"
import { Button, Modal } from "@prosolve/common-components-ui"
import { FaTrash, FaTimes } from "react-icons/fa"

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 420px;
  max-width: calc(100vw - 80px);
`

const RowGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const MutedText = styled.div`
  color: ${({ theme }) => theme.colors.lightText};
  font-size: 13px;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 10px;
`

export default ({
  job,
  description = 'This will also remove the saved run history for this job.',
  onConfirm,
  onClose
}) => {
  const footer = (
    <ButtonsContainer>
      <Button onClick={onClose}>
        <RowGroup>
          <FaTimes />
          Cancel
        </RowGroup>
      </Button>
      <Button $colored={true} onClick={onConfirm}>
        <RowGroup>
          <FaTrash />
          Delete
        </RowGroup>
      </Button>
    </ButtonsContainer>
  )

  return createPortal(
    <Modal
      title='Delete Job'
      isAutoHeight={true}
      isAutoWidth={true}
      onClose={onClose}
      footer={footer}
    >
      <ModalContainer>
        <div>Delete {job.name}?</div>
        <MutedText>{description}</MutedText>
      </ModalContainer>
    </Modal>,
    document.body
  )
}
